// app_client/src/pages/admin/ModuleManagement.jsx
import React, { useEffect, useState } from 'react';
import useModuleStore from '../../store/useModuleStore';
import { 
  ShieldCheck,
  Settings,
  Lock,
  Unlock,
  RefreshCw,
  AlertCircle,
  Plus
} from 'lucide-react';
import ModuleFormModal from '../../components/modals/ModuleFormModal';

const ModuleManagement = () => {
  const { modules, loading, fetchModules, toggleModuleStatus } = useModuleStore();
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    fetchModules();
  }, [fetchModules]);

  return (
    <div className="p-8 max-w-6xl mx-auto space-y-8">
      {/* Header */}
      <div className="flex justify-between items-end">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <ShieldCheck className="text-indigo-600" size={24} />
            <h1 className="text-3xl font-black text-slate-800 tracking-tight">Sistem Modülleri</h1>
          </div>
          <p className="text-slate-500 font-bold uppercase text-[10px] tracking-widest italic">
            Yazılım Lisans ve Modül Yetkilendirme
          </p>
        </div>
        <div className="flex gap-2">
          <button 
            onClick={fetchModules}
            className="p-3 bg-white border border-slate-100 rounded-2xl text-slate-400 hover:text-indigo-600 hover:shadow-md transition-all"
          >
            <RefreshCw size={20} className={loading ? 'animate-spin' : ''} />
          </button>
          <button 
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-2xl font-black text-xs uppercase tracking-widest transition-all shadow-lg active:scale-95"
          >
            <Plus size={18} /> Yeni Modül Tanımla
          </button>
        </div>
      </div>

      {/* Uyarı Banner'ı (Superuser Hatırlatması) 
      <div className="bg-amber-50 border-2 border-amber-100 p-6 rounded-4xl flex items-start gap-4">
        <div className="p-3 bg-white rounded-2xl text-amber-500 shadow-sm">
          <AlertCircle size={24} />
        </div>
        <div>
          <h4 className="font-black text-amber-800 text-sm uppercase tracking-tight">Lisans Kontrol Notu</h4>
          <p className="text-amber-700/80 text-sm font-medium leading-relaxed mt-1">
            Buradaki değişiklikler tüm kullanıcıların Sidebar menüsünü ve yetki erişimlerini anında etkiler. 
            Ödeme gecikmesi durumunda modülleri pasife alarak erişimi kısıtlayabilirsiniz.
          </p>
        </div>
      </div>
      */}

      {/* Modül Listesi */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {loading ? (
          <div className="col-span-full py-20 text-center font-black text-slate-300 animate-pulse uppercase tracking-widest text-sm">
            Sistem Konfigürasyonu Okunuyor...
          </div>
        ) : (
          modules.map((mod) => (
            <div 
              key={mod._id} 
              className={`bg-white rounded-[2.5rem] border-2 p-6 transition-all flex items-center justify-between ${
                mod.isActive ? 'border-slate-50 shadow-sm' : 'border-slate-100 opacity-60 grayscale'
              }`}
            >
              <div className="flex items-center gap-5">
                <div className={`p-4 rounded-2xl ${mod.isActive ? 'bg-indigo-50 text-indigo-600' : 'bg-slate-100 text-slate-400'}`}>
                  <Settings size={24} />
                </div>
                <div>
                  <h3 className="font-black text-slate-800 text-lg tracking-tight leading-none">{mod.label}</h3>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-tighter mt-1">
                    Route: <span className="font-mono">{mod.key}</span>
                  </p>
                </div>
              </div>

              {/* Toggle Action */}
              <button
                onClick={() => toggleModuleStatus(mod._id, mod.isActive)}
                className={`flex items-center gap-2 px-6 py-3 rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all ${
                  mod.isActive 
                    ? 'bg-emerald-500 text-white shadow-lg shadow-emerald-200 hover:bg-emerald-600' 
                    : 'bg-slate-200 text-slate-500 hover:bg-slate-300'
                }`}
              >
                {mod.isActive ? <Unlock size={14} /> : <Lock size={14} />}
                {mod.isActive ? 'Aktif' : 'Kapalı'}
              </button>
            </div>
          ))
        )}
      </div>

      <ModuleFormModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default ModuleManagement;